var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLotteryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lotteryIcon_svg__clip0_lottery_menu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.952 7.259v5.484a1.563 1.563 0 00-1.22 1.215H4.242a1.56 1.56 0 00-1.219-1.215V7.26a1.562 1.562 0 001.22-1.215h11.49c.124.61.608 1.09 1.219 1.215zM19.208 8.6c0 .28.22.516.503.536a.312.312 0 01.289.31v1.105a.31.31 0 01-.289.31.542.542 0 00-.503.537c0 .279.22.515.503.536a.312.312 0 01.289.31v1.79a.31.31 0 01-.312.31 1.35 1.35 0 00-1.35 1.345.31.31 0 01-.312.31H1.974a.31.31 0 01-.312-.31 1.35 1.35 0 00-1.35-1.345.31.31 0 01-.312-.31V12.24c0-.16.12-.292.278-.309a.54.54 0 00.489-.533.542.542 0 00-.489-.536.31.31 0 01-.278-.308v-1.11c0-.159.12-.291.278-.308a.54.54 0 00.489-.536.541.541 0 00-.489-.535A.31.31 0 010 7.757V5.966c0-.172.14-.31.312-.31a1.35 1.35 0 001.35-1.346c0-.171.14-.31.312-.31h16.052a.31.31 0 01.312.31c0 .741.607 1.345 1.35 1.345a.31.31 0 01.312.31v1.79a.31.31 0 01-.289.31.542.542 0 00-.503.536zM17.575 6.98a.31.31 0 00-.311-.31.939.939 0 01-.94-.935.31.31 0 00-.311-.31H3.963a.31.31 0 00-.312.31.939.939 0 01-.94.935.31.31 0 00-.311.31v6.044c0 .171.139.31.311.31.518 0 .94.42.94.935 0 .172.139.31.311.31h12.05a.31.31 0 00.313-.31c0-.515.421-.935.939-.935a.31.31 0 00.311-.31V6.979z",
    fill: "#9A9CAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lotteryIcon_svg__clip0_lottery_menu"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgLotteryIcon;